import React from 'react'
// ##
import PriceOffersTable from '../../modules/PriceOffer/components/PriceOffersTable'

export default function PriceOfferPage() {
  return <PriceOffersTable />
}
